import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodFolder } from "../../assets/Podcast/PodFolder";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .contract {
      padding: 0.7rem 1rem;
      display: flex;
      box-shadow: 0px 4px 8px -2px #00000040;
      border-radius: 4px;
      .expand {
        flex-grow: 1;
      }
      .date {
        width: 33%;
      }
      .more-info {
        color: blue;
        cursor: pointer;
      }
      &.header {
        font-weight: 700;
      }
    }
  }
`;


function WorkPageContracts(props) {
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodFolder/></div>
            <div className="text">Contracts</div>
          </div>
      </div>
      <div className="content">
        <div className="contract header">
          <div className="date">start date</div>
          <div className="date">end date</div>
          <div className="more-info"></div>
        </div>
        {/* <div className="contract">
          <div className="date">1402/02/01</div>
          <div className="date">1402/06/01</div>
          <div className="expand"></div>
          <div className="more-info"></div>
        </div> */}
      </div>
    </StyleCss>
  )
}
export default WorkPageContracts;